import Button from '@mui/material/Button';
import { ReactElement } from 'react';

import { IMedicaidPlanClient } from '~/services/api/medicaidPlan/types';
import Modal from '~/ui/components/common/Modal';

import { ActivePlanEngagement } from '../PlanEngagement';

import styles from './CeHistoryModal.module.scss';

interface ICeHistoryModalProps {
  client: IMedicaidPlanClient;
  onClose: () => void;
}

const CeHistoryModal = ({ client, onClose }: ICeHistoryModalProps): ReactElement => (
  <Modal open maxWidth={false} className={styles.paper} onClose={onClose}>
    <section className={styles.container}>
      <header className={styles.header}>
        <h2 className={styles.title}>Community Engagement</h2>
      </header>
      <div className={styles.content}>
        <ActivePlanEngagement client={client} />
      </div>
      <footer className={styles.actions}>
        <Button color="primary" variant="contained" onClick={onClose}>
          Close
        </Button>
      </footer>
    </section>
  </Modal>
);

export default CeHistoryModal;
